import React, { useState, useEffect } from 'react'
import VisualizacaoPadrao from '../../../../components/VisualizacaoPadrao'
import { useParams } from "react-router-dom";
import { visualizar } from '../../../../util/AcessoApi'
import { ordenarArrayObj } from '../../../../util/FuncoesComuns';

const Visualizacao = (props) => {
    let { id } = useParams();
    const [dados, setDados] = useState()

    useEffect(() => {
        visualizar('/faturamento/cooperadopf', id,
            obj => {
                setDados(obj.id ? {
                    id,
                    modulo: props.modulo,
                    titulo: 'Visualização de Cooperado PF',
                    grupos: [
                        {
                            titulo: 'Dados Gerais',
                            colunas: [
                                { titulo: 'Código', descricao: obj.id, tamanho: 'col-lg-4' },
                                { titulo: 'Nome', descricao: obj.nome, tamanho: 'col-lg-4' },
                                { titulo: 'CPF', descricao: obj.cpf, tamanho: 'col-lg-4' },
                                { titulo: 'Data de Nascimento', descricao: obj.data_nascimento, tamanho: 'col-lg-4' },
                                { titulo: 'CNES', descricao: obj.cnes, tamanho: 'col-lg-4' },
                                { titulo: 'Naturalidade', descricao: obj.naturalidade?.label, tamanho: 'col-lg-4' },
                                { titulo: 'Inscrição Municipal', descricao: obj.inscricao_municipal, tamanho: 'col-lg-4' },
                                { titulo: 'Inscrição INSS', descricao: obj.inscricao_inss, tamanho: 'col-lg-4' },
                                { titulo: 'RG', descricao: obj.rg, tamanho: 'col-lg-4' },
                                { titulo: 'Data de Expedição do RG', descricao: obj.data_expedicao, tamanho: 'col-lg-4' },
                                { titulo: 'UF do Órgão Expedidor', descricao: obj.uf_orgao_expedidor?.label, tamanho: 'col-lg-4' },
                                { titulo: 'Órgão Expedidor do RG', descricao: obj.orgao_expedidor, tamanho: 'col-lg-4' },
                                { titulo: 'Nome do Pai', descricao: obj.nome_pai, tamanho: 'col-lg-4' },
                                { titulo: 'Nome da Mãe', descricao: obj.nome_mae, tamanho: 'col-lg-4' },
                                { titulo: 'Ano de Formatura', descricao: obj.ano_formatura, tamanho: 'col-lg-4' },
                                { titulo: 'Telefone', descricao: obj.telefone, tamanho: 'col-lg-4' },
                                { titulo: 'Celular', descricao: obj.celular, tamanho: 'col-lg-4' },
                                { titulo: 'E-mail', descricao: obj.email, tamanho: 'col-lg-4' },
                                { titulo: 'Sexo', descricao: obj.sexo?.label, tamanho: 'col-lg-4' },
                                { titulo: 'Código da Operadora', descricao: obj.codigo_operadora, tamanho: 'col-lg-4' },
                                { titulo: 'Estado Civil', descricao: obj.estado_civil?.label, tamanho: 'col-lg-4' },
                                { titulo: 'Data de Admissão', descricao: obj.data_admissao, tamanho: 'col-lg-4' },
                                { titulo: 'País de Nascimento', descricao: obj.pais_nascimento?.label, tamanho: 'col-lg-4' },
                                { titulo: 'País de Nacionalidade', descricao: obj.pais_nacionalidade?.label, tamanho: 'col-lg-4' },
                                { titulo: 'Grau de Instrução', descricao: obj.grau_instrucao?.label, tamanho: 'col-lg-4' },
                                { titulo: 'Raça', descricao: obj.raca?.label, tamanho: 'col-lg-4' }
                            ]
                        }
                    ]
                } : { titulo: 'Visualização de Cooperado PF' })
            })
    }, [id])

    return dados ? <VisualizacaoPadrao data={dados} {...props} /> : null
}

export default Visualizacao